import { REQUIRED_FIELD } from '@src/utils';
import * as yup from 'yup';

export const schema = yup.object({
  laboratoryId: yup.string().nullable().required(REQUIRED_FIELD),
  providerId: yup.string().nullable(),
  patientIds: yup.array().of(yup.string().required(REQUIRED_FIELD)).min(1).required(REQUIRED_FIELD),
  diagnosisIds: yup
    .array()
    .of(
      yup.object({
        id: yup.string().required(REQUIRED_FIELD),
      }),
    )
    .required(REQUIRED_FIELD)
    .nullable(),
  additionalProductIds: yup
    .array()
    .of(
      yup.object({
        id: yup.string().required(REQUIRED_FIELD),
      }),
    )
    .required(REQUIRED_FIELD)
    .nullable(),

  productsByLoincItems: yup.array().of(
    yup.object({
      loincItemId: yup.string().required(REQUIRED_FIELD),
      productId: yup.string(),
    }),
  ),
});
